module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_5-e61ce97b416c76fefc4ae79c79ee7161.png";